import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const DoctorPatientDashboard = () => {
  const [patients, setpatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const navigate = useNavigate();

  const getpatientdetails = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/patient_details_interaction",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setpatients(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const getpatientdetailssearch = async (value) => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/patient_details_interaction",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setpatients(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      console.error("Error Details:", error.message);
      setAlert(true);
      setMessage("Please try again later, something went wrong");
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentPagePath = window.location.pathname;
      const loginBool = localStorage.getItem("login");

      if (loginBool === "true") {
        navigate("/doctor-dashboard", { state: { url: currentPagePath } });
        await getpatientdetails();
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    };

    init();
  }, []);

  // Optional: debounce search (delays request as user types)
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getpatientdetailssearch(searchTerm.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleView = (path, patient_id) => navigate(path, { state: { patient_id } });
  const handleViewprecription = (path, patient_id, patient_name) => navigate(path, { state: { patient_id, patient_name } });
  return (
    <div className="min-h-screen bg-gradient-to-r from-sky-50 to-blue-100 p-4 pt-24">
      <h1 className="text-3xl font-bold text-blue-800 mb-6 text-center">
        Doctor Dashboard – Patients Overview
      </h1>

      <div className="flex justify-center mb-8">
        <input
          type="text"
          placeholder="Search by name, phone, or ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-md px-4 py-2 rounded-lg border border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {patients.map((patient) => (
          <div
            key={patient.id}
            className="bg-white rounded-xl shadow-md border border-blue-200 p-3"
          >
            <h2 className="text-lg font-semibold text-blue-700">{patient.name}</h2>
            <p className="text-gray-600 text-xs mt-1">Phone: {patient.phone}</p>
            <p className="text-gray-600 text-xs">Age: {patient.age}</p>
            <p className="text-gray-600 text-xs">Gender: {patient.gender}</p>

            <div className="mt-3 space-y-1.5">
              <button onClick={() => handleView("/chat_history", patient.id)} className="w-full bg-sky-600 hover:bg-sky-700 text-white py-1 rounded text-xs">View Chat History</button>
              <button onClick={() => handleView("/view_appointment", patient.id)} className="w-full bg-green-600 hover:bg-green-700 text-white py-1 rounded text-xs">View Appointments</button>
              <button onClick={() => handleView("/view_lab_test", patient.id)} className="w-full bg-purple-600 hover:bg-purple-700 text-white py-1 rounded text-xs">View Lab Tests</button>
              <button onClick={() => handleView("/view_reminder", patient.id)} className="w-full bg-pink-500 hover:bg-pink-600 text-white py-1 rounded text-xs">View Reminders</button>
              <button onClick={() => handleView("/view_reminder_report", patient.id)} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-1 rounded text-xs">Get Reminders Report</button>
              <button onClick={() => handleView("/chat_summary", patient.id)} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-1 rounded text-xs">View Patient Summary</button>
              <button onClick={() => handleViewprecription("/write_prescription", patient.id, patient.name)} className="w-full bg-red-600 hover:bg-red-700 text-white py-1 rounded text-xs">✍️ Write Prescription</button>
              <button
                onClick={() => handleView("/prescription_history", patient.id)}
                className="w-full bg-yellow-600 hover:bg-yellow-700 text-white py-1 rounded text-xs"
              >
                📄 View Prescription History
              </button>
              <button
                onClick={() => handleView("/doctor_prescription", patient.id)}
                className="w-full bg-teal-600 hover:bg-teal-700 text-white py-1 rounded text-xs transition-colors duration-200"
              >
                ✏️ Record Prescription
              </button>

              {/* 📌 Added message under Record Prescription */}
              <p className="text-xs text-gray-600 mt-1 italic">
                Please mention medicine timings as <span className="font-semibold">10:00 AM, 11:11 PM</span> so we can set reminders for patients from the prescription itself.
              </p>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
};

export default DoctorPatientDashboard;